module.exports = __webpack_public_path__ + "img/pay-sublocations.4255754b.svg";